// extracted by mini-css-extract-plugin
module.exports = {"button":"InstagramButton_button__21M9c","text":"InstagramButton_text__3J0uj","icon":"InstagramButton_icon__WBusZ"};